<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Ajout des plannings <strong>{{guichet.nom}}</strong>  
          </div>
          <b-row class="form-group">
             <!-- <b-col md="6" v-if="display_atm">
              <label for="guichet_id">Guichet</label>
               <b-form-select id="guichet_id" :plain="true" :options="options_atm" v-model="planning.guichet_id">
              </b-form-select>
            </b-col> -->
            <b-col md="6" v-if="display_atm">
              <label for="guichet_id">Guichet *</label>
                <el-select style="display:block;"
                  id="guichet_id"
                  v-model="planning.guichet_id"
                  loading-text="Chargement en cours"
                  no-match-text="Guichet non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre guichet"
                  :remote-method="remoteATM"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
            <b-col md="6">
              <label for="user_id">Utilisateur </label>
                <el-select style="display:block;"
                  id="user_id"
                  v-model="planning.user_id"
                  loading-text="Chargement en cours"
                  no-match-text="Utilisateur non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre utilisateur"
                  :remote-method="remoteUser"
                  :loading="loading">
                  <el-option
                    v-for="item in options5"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
            <!-- <b-col md="6">
              <label for="user_id">Utilisateur</label>
              <b-form-select id="user_id" :plain="true" :options="options" v-model="planning.user_id">
              </b-form-select>
            </b-col> -->
          </b-row>
          <b-row class="form-group">
           
            <b-col md="6">
              <label for="montant_min">Date</label>
              <!-- <b-form-input type="date" v-model="planning.date" placeholder="AAAA-MM-JJ"></b-form-input> -->
              <el-date-picker
                style="width:100%;"
                v-model="planning.date"
                type="date"
                placeholder="Choisir une date"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions1">
              </el-date-picker>
            </b-col>
            <b-col md="3">
              <label for="solde">De</label>
              <b-form-input type="time" v-model="planning.heure_debut" placeholder="HH:MM"></b-form-input>
            </b-col>
            <b-col md="3">
              <label for="solde">A</label>
              <b-form-input type="time" v-model="planning.heure_fin" placeholder="HH:MM"></b-form-input>
            </b-col>
          </b-row> 
         
          <div slot="footer">
            <span v-if="can('planning-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      userConnected:{},
      display_atm:true,
      options : [],
      options_atm : [],
      planning:{
        guichet_id: '',
        user_id: '',
        date: '',
        heure_debut: '',
        heure_fin: ''
      },
      pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < (Date.now()- 3600 * 1000 * 24);
          },
          shortcuts: [{
            text: "Aujourd'hui",
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: 'Hier',
            onClick(picker) {
              const date = new Date();
              
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: 'Semaine avant',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
      },
      user:[],
      atm:[],
      guichet:{},
      value5: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],

      options4: [],
      options5: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
      goBack() {
        this.$router.go(-1)
      },
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      can(perm){
        return store.getters['auth/can'](perm)
      },
      async post(){     
          let temp_date = this.planning.date
          this.planning.date = this.planning.date.toISOString().split('T')[0]
          this.response = await this.$store.dispatch('planning/post_planning',this.planning)
          this.showAlert()
          if (this.response.success==true){

            this.reset()
          }
          this.planning.date = temp_date
      },
      async get_all_users(){
          let token = localStorage.getItem("token")
          let user = await api.user.get_auth_users(token)
          this.userConnected = await store.getters['auth/get_user']
          //console.log("user connectedddd : ",user.data.data.id)
          let serverParams = {
              name:'',
              email:'',
              entite_nom:'',
              agence_nom:'',
              agence_ville:'',
              role_name:'',
             
              created_at:'',
              page:1,
              current_page: 1,
              nb_lines:20

          }
          await this.$store.dispatch('user/get_all_users_by_user',serverParams).then(()=>{
              return this.user = store.getters['user/rows'];    
          })
          //if (this.userConnected.role.toUpperCase() == 'CHEF AGENCE'){
          //let users=this.user.filter(element=>element.role.toUpperCase() != 'CHEF AGENCE')
          this.user.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.name
              })
          })    
      },
      async get_all_atm(){
          let serverParams = {
              page:1
          }
          //this.atm =  store.getters['atm/rows'];
          if(this.$route.params.guichet_id===null || this.$route.params.guichet_id==='null'){
            await this.$store.dispatch('atm/guichet_active',serverParams).then(()=>{
              return this.atm = store.getters['atm/rows_active'];    
            })
            this.display_atm = true
            this.atm.forEach((element)=>{
              this.options_atm.push({
                  value:element.id,
                  text:element.nom
                })
            })
          }else{
            await this.$store.dispatch('atm/show_guichets',this.$route.params.guichet_id).then((res)=>{
              return this.guichet = res   
            })
            this.display_atm = false
            this.planning.guichet_id = this.$route.params.guichet_id
            this.options_atm.push({
              value:this.$route.params.guichet_id,
              text:this.$route.params.guichet_id
            })
          }
      },
      
      reset() {
        this.planning.date= '',
        this.planning.heure_debut= '',
        this.planning.heure_fin= ''
      },
      setting(){
      var q = new Date();
      var m = q.getMonth();
      var d = q.getDate();
      var y = q.getFullYear();
      var date = new Date(y, m, d);
      this.planning.date = date
      console.log("ma data",date)
    },
      remoteATM(query){
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.options_atm.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options4 = [];
        }
      },
      remoteUser(query){
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.options.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options5 = [];
        }
      }
  },
  mounted(){
    this.setting()
    this.get_all_users()
    this.get_all_atm()
  }
}
</script>
